import raw from "../../rawClients/rawCapiClient";
import routes from "../../capiRoutes";
import projectUserSerializer from "../../serializers/projectUser";
import restrictedUserSerializer from "../../serializers/restrictedUser";
export default {
  /** Returns the token user's profile */
  getProfile() {
    return raw.get(routes.users.profile());
  },
  /** Returns all users on a project. Users are sorted by email descending. */
  getAllInProject(projectUid) {
    return raw
      .getAll(routes.users.allInProject(projectUid))
      .then(projectUsers => projectUsers.map(projectUserSerializer.fromServer));
  },
  /**
   *  Add a user to the project team and send an email invite to join the
   *  project. API user must have permissions to invite project team members
   *  (Currently only admins can invite).
   */
  inviteToProject(projectUid, invitation) {
    return raw.post(routes.users.inviteToProject(projectUid), {
      email: invitation.email,
      role_uid: invitation.roleUid,
    });
  },
  /**
   *  Returns all restricted users on a project.
   */
  getRestrictedAssignees(projectUid) {
    return raw
      .getAll(routes.users.restrictedAssignees(projectUid))
      .then(users => users.map(restrictedUserSerializer.fromServer));
  },
  /**
   *  Invite a restricted user to the project without adding to the
   *  team. API user must have permissions to invite restricted members
   *  (Currently only admins and RFI managers can invite).
   */
  inviteRestrictedAssignee(projectUid, invitation) {
    return raw.post(routes.users.restrictedAssignees(projectUid), {
      email: invitation.email,
    });
  },
};
